import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api, { TOKEN_KEY } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const [ok, setOk] = useState(null); // null = checking

  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setOk(false); return; }
    api.get("/auth/me")
      .then((r) => setOk(!!r.data.authenticated))
      .catch(() => setOk(false));
  }, []);

  if (ok === null) {
    return (
      <div className="dark min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-primary animate-spin" />
      </div>
    );
  }
  if (!ok) return <Navigate to="/login" replace />;
  return children;
}
